import { Box } from '@mui/material'
import React from 'react'

interface HighlightProps {
  text: string;
  query: string;
}

export default function Highlight(props: HighlightProps): React.ReactElement {
  const { text, query } = props

  if (!query?.trim()) {
    return <>{text}</>
  }

  if (!text) {
    return <></>
  }

  const parts = text.split(new RegExp(`(${query})`, 'gi'))

  return (
    <>
      {parts.map((part, i) => {
        if (part.toLowerCase() === query.toLowerCase()) {
          return (
            <Box
              key={i}
              component="span"
              sx={{
                backgroundColor: 'primary.light',
                color: 'primary.contrastText',
                fontWeight: 600,
                px: 0.5,
                borderRadius: 0.5,
              }}
            >
              {part}
            </Box>
          )
        }

        return part
      })}
    </>
  )
}
